export const isAnObject = (value: any) => typeof value === 'object' && !Array.isArray(value) && value !== null;